import { render, staticRenderFns } from "./20191107.vue?vue&type=template&id=2634a801"
import script from "./20191107.vue?vue&type=script&lang=js"
export * from "./20191107.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports